import { Card, Container, Text, VStack } from '@chakra-ui/react'
import React from 'react'

export default function CancellationAndRefund() {
    return (
        <>


            <Container maxW='8xl' my='6' minH='60vh'>
                <VStack w='100%' spacing='4'>
                    <Card p='5' w='100%'>
                        <Text fontSize='2xl' fontWeight='800' className='customfont'>Cancellation and Refunds</Text>
                    </Card>
                    <Card p='5' w='100%'>
                        <VStack w='100%' spacing='4' alignItems='start'>

                            <Text>
                                At COCO, we take great care to create each piece of clothing as per order, ensuring the highest quality and craftsmanship. Due to this, we do not have a general return policy.
                            </Text>

                            <Text>Any kind of return requests made due to incorrect size selection or inaccurate body measurements given for custom pieces will not be taken into consideration. We request you to double check the size chart before placing an order. </Text>

                            <Text>Since most of our products listed on the website are hand embroidered there are chances of the embroidery material coming off during the course of transit. We are not liable for any such damage. </Text>

                            <Text>However, we understand that there may be certain situations where a return or refund is necessary. Please read our policy carefully to understand the conditions under which we will accept returns and provide refunds. </Text>

                            <Text>Return Conditions </Text>

                            <Text>You may return your order if:</Text>

                            <Text>The item is wrongly sent or has a defect. The item should be intimated within 24 hours of delivery.
                            Damage due to shipping is not covered under this policy
                            In the event that you need to return your order, please contact us at (cocokids@gmail.com) to initiate the return process.</Text>

                            <Text>Please note that return couriers must be borne by the buyer. Shipping charges are non refundable. We recommend using a trackable shipping service and retaining proof of postage in case the item is lost in transit.</Text>

                            <Text>Once we receive the product back, we will check it for any defects or damage. If the product is eligible for a refund or exchange, we will notify you via email.</Text>

                            <Text>Refund & Exchange</Text>

                            <Text>If your return is eligible for a refund, we will process it within 10-15 business days. Please note that refunds will only be processed to the original payment method.</Text>

                            <Text>If you've received wrong product, we will issue the exchange and the product will be replaced and dispatched within one week of receiving the original product.
                            Please keep in mind that since each piece is hand dyed, stitched and embroidered, there may be slight variation in every piece. Additionally, the colors of the actual outfit may vary from screen to real.</Text>

                            <Text>If you have any questions about our return and refund policy, please do not hesitate to contact us at (cocokids@gmail.com)</Text>
                        

                </VStack>
            </Card>
        </VStack >
            </Container >

        </>
    )
}
